import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHouseListTree, insert, update, getDetail, fetchShareMeterList } from '@/api/PMS/baseInformation/meterManager';
import { fetchList as getMeterTypeList } from '@/api/PMS/baseInformation/meterType';
export default {
  data: function data() {
    return {
      rules: {
        houseId: [{
          required: true,
          message: '请选择房间',
          trigger: 'change'
        }],
        meterId: [{
          required: true,
          message: '请选择仪表类型',
          trigger: 'change'
        }],
        initDate: [{
          required: true,
          message: '请选择初始日期',
          trigger: 'blur'
        }],
        maxReadNumber: [{
          required: true,
          type: 'number',
          message: '请输入最大读数，类型为数字,0<=最大读数<=100000',
          trigger: 'blur',
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        initReadNumber: [{
          required: true,
          type: 'number',
          message: '请输入初始读数，类型为数字，0<=初始读数<=100000',
          trigger: 'blur',
          max: 100000,
          min: 0,
          transform: function transform(value) {
            return Number(value);
          }
        }],
        meterMagnification: [{
          required: true,
          type: 'number',
          message: '请输入倍率，类型为数字,0<倍率<100',
          max: 99.99,
          min: 0.01,
          trigger: 'blur',
          transform: function transform(value) {
            return Number(value);
          }
        }],
        wastingRate: [{
          type: 'number',
          transform: function transform(value) {
            console.log(Number(value));
            if (value !== undefined && value !== null) return Number(value);
          },
          max: 99.99,
          min: 0,
          message: '损耗率类型为数字,类型为数字,0<=损耗率<100',
          trigger: 'blur'
        }],
        meterName: [{
          required: true,
          message: '请输入仪表名称，仪表名称1-20个字符',
          trigger: 'blur',
          max: 20,
          min: 0
        }]
      },
      shareMeterList: [],
      meterTypeList: [],
      houseList: [],
      childData: {
        isMaster: 1,
        isReadNumber: 1
      }
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
    this.loadMeterTypeList();
  },
  methods: {
    // 获取用户信息
    getCustomerInfo: function getCustomerInfo(data) {
      // 此处要排除undefined情况，否则会多查询一次
      if (data !== undefined) {
        this.getcustomerHouseData(data);
      }
    },
    // 获取客户房间信息
    getcustomerHouseData: function getcustomerHouseData(data) {
      var _this = this;

      getHouseListTree({
        houseInfo: data
      }).then(function (r) {
        _this.houseList = r.data.data;
      });
    },
    init: function init() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          houseMeterId: this.keyValue
        };
        getDetail(queryData).then(function (response) {
          _this2.childData = response.data.data;

          _this2.customerChange(undefined);

          _this2.getCustomerInfo(_this2.childData.houseCode);
        });
      } else {
        this.childData = {
          meterName: '',
          isMaster: 1,
          isReadNumber: 1
        };
      }
    },
    // 企业选择发生变化的时候触发
    customerChange: function customerChange(type) {
      var _this3 = this;

      // 清理总表id
      if (this.childData.shareMeterId && type !== undefined) {
        delete this.childData.shareMeterId;
      } // 更换房间相关的区域数据


      this.houseList.forEach(function (item) {
        if (item.houseId === _this3.childData.houseId) {
          _this3.childData.areaId = item.areaId;
        }
      });
      this.loadShareMeterList();
    },
    // 获取总表列表
    loadShareMeterList: function loadShareMeterList() {
      var _this4 = this;

      fetchShareMeterList({
        shareType: 1,
        areaId: this.childData.areaId
      }).then(function (r) {
        _this4.shareMeterList = r.data.data;
      });
    },
    // 获取仪表类型
    loadMeterTypeList: function loadMeterTypeList() {
      var _this5 = this;

      getMeterTypeList({}).then(function (r) {
        _this5.meterTypeList = r.data.data;
      });
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          console.log(_this6.childData.maxReadNumber < _this6.childData.initReadNumber, _this6.childData.maxReadNumber, _this6.childData.initReadNumber);

          if (+_this6.childData.maxReadNumber < +_this6.childData.initReadNumber) {
            return _this6.Alert({
              alertType: 'valid',
              message: '初始读数不能大于最大读数！'
            });
          }

          if (_this6.keyValue > 0) {
            update(_this6.childData).then(function (response) {
              if (response.data.code === 200) {
                _this6.$emit('handCancle', true);

                _this6.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            insert(_this6.childData).then(function (response) {
              if (response.data.code === 200) {
                _this6.$emit('handCancle', true);

                _this6.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};